import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Status badge for Raise Hand / BRB on participant video tiles
// Design matches studiodev TileReaction.jsx StatusBadge
export default function StatusBadge({ status }) {
  if (!status) return null;

  const badges = {
    hand_raised: {
      emoji: '✋',
      bg: 'bg-yellow-500/80',
      label: 'Hand Raised'
    },
    brb: {
      emoji: '⏳',
      bg: 'bg-orange-500/80',
      label: 'Be Right Back'
    }
  };

  const badge = badges[status];
  if (!badge) return null;

  // Use inline style for background color to ensure it's applied
  const bgColors = {
    hand_raised: 'rgba(234, 179, 8, 0.8)',  // yellow-500 with 80% opacity
    brb: 'rgba(249, 115, 22, 0.8)'          // orange-500 with 80% opacity
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 0.5 }}
        className="absolute top-2 left-2 backdrop-blur-sm rounded-lg px-2 py-1 shadow-lg flex items-center gap-1.5 z-20"
        style={{ backgroundColor: bgColors[status] }}
      >
        <span className="text-sm">{badge.emoji}</span>
        <span className="text-xs text-white font-medium">{badge.label}</span>
      </motion.div>
    </AnimatePresence>
  );
}
